import React, { useEffect } from 'react';
import { func, string, bool } from 'prop-types';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';

import { Form, PrimaryButton } from '../..';

import css from './InquiryWithoutPaymentForm.module.css';
import InfoBox from '../InfoBox/InfoBox';
import SmallPrint from '../SmallPrint/SmallPrint';

const renderForm = formRenderProps => {
  // FormRenderProps from final-form
  const {
    form,
    formId,
    className,
    rootClassName,
    handleSubmit,
    params,
    displayInfoBox,
    contactForPricingFlag,
    displayAdditional,
    userPublicData,
    authorId,
    isOwnListing,
  } = formRenderProps;
  const classes = classNames(rootClassName || css.root, className);

  useEffect(() => {
    if (contactForPricingFlag) {
      handleSubmit(form);
    }
  }, [contactForPricingFlag]);

  return (
    <Form id={formId} onSubmit={handleSubmit} className={classes}>
      {displayInfoBox ? <InfoBox
        authorId={authorId}
        onClick={handleSubmit}
        infoBoxText={userPublicData?.infoBoxText}
        isOwnListing={isOwnListing}
      /> : null}
      <div className={css.submitButton}>
        <PrimaryButton type="submit">
          <FormattedMessage id="InquiryWithoutPaymentForm.ctaButton" />
        </PrimaryButton>
      </div>

      {displayAdditional ? <SmallPrint authorId={authorId} /> : null}
    </Form>
  );
};

const InquiryWithoutPaymentForm = props => {
  const intl = useIntl();
  const initialValues = {};

  return <FinalForm initialValues={initialValues} {...props} intl={intl} render={renderForm} />;
};

InquiryWithoutPaymentForm.defaultProps = {
  rootClassName: null,
  className: null,
  displayInfoBox: false,
  contactForPricingFlag: false,
  displayAdditional: false,
  userPublicData: null,
};

InquiryWithoutPaymentForm.propTypes = {
  rootClassName: string,
  className: string,

  // form
  formId: string.isRequired,
  onSubmit: func.isRequired,

  displayInfoBox: bool,
  contactForPricingFlag: bool,
  displayAdditional: bool,
};

export default InquiryWithoutPaymentForm;
